export const ALBUM_TYPE_BADGE: { [key: string]: string } = {
  classic: 'Happy Wallet',
  premier: "Couples' Pick",
  deluxe: 'Wow-Factor',
};

export const ALBUM_TYPE_DESCRIPTION: { [key: string]: string } = {
  classic: 'Just the essentials: layflat, linen cover, photographic printing, and thick pages.',
  premier: 'The essentials, with more oomph: luxe cover options and extra-thick pages.',
  deluxe: 'The essentials, all jazzed up. Think Italian leather cover and extra-thick pages.',
};
